<template>
    <transition name="bottom-up-modal">
        <div v-if="show" class="modal-mask" :style="{ zIndex }">
            <div class="modal-overlay" @click="close" />
            <div :class="{'full-max-height': fullMaxHeight}" class="modal-container" @transitionend="show && $emit('shown')">
                <div class="modal-body" :class="bodyClass">
                    <slot>
                        <!--TODO: Implement default body-->
                    </slot>
                </div>

                <div class="modal-footer" v-if="$slots.footer">
                    <slot name="footer" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Modal from '~/components/common/modal/modal';

export default {
    extends: Modal,

    props: {
        fullMaxHeight: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~vars';

    .modal-container {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: auto;
        overflow: auto;
        border-radius: 20px 20px 0 0;
        max-height: 80%;
        height: auto;
        width: 100%;

        &.full-max-height {
            max-height: 100vh;
        }

        .modal-body {
            padding: 10px 15px;
            overflow: auto;
        }

        @media (min-width: 370px) {
            width: calc(100% - 20px);
        }
    }

    .modal-footer {
        border: none;
        padding: 0;
        justify-self: flex-end;
        margin-top: auto;
    }

    /* Animation */

    .bottom-up-modal {

        &-enter-active, &-leave-active {
            transition: opacity 0.3s ease;

            .modal-overlay {
                transition: background-color 0.3s ease;
            }

            .modal-container {
                transition: transform 0.3s ease;
            }
        }

        &-enter, &-leave-to {
            opacity: 0.98;

            .modal-overlay {
                background-color: transparent;
            }

            .modal-container {
                transform: translate3d(0, 100%, 0);
            }
        }
    }
</style>
